import React, { useState } from "react";
import {
  Typography,
  Grid,
  useTheme,
  TextField,
  Button,
  IconButton,
  useMediaQuery,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import axios from "axios";
import PropTypes from "prop-types";
import CustomPaginationActionsTable from "./tableComponent";
import { toast } from "react-toastify";

const ListComponent = ({
  setList,
  handleClick,
  handleChange,
  heading,
  sip,
  makeCall,
  // data,
}) => {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("xs"));
  const [data, setData] = React.useState();
  const [page, setPage] = React.useState(0);
  const [offset, setOffset] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filter, setFilter] = useState({
    status: "CREATED,RESERVED",
    roomType: "",
  });
  const roomTypes = [
    "Audio",
    "Video-VAS",
    "Video-CPV-6-split",
    "Video-CPV-4-split",
    "Video-CPV-Auto-split",
    "Video-CPV-DHL",
  ];

  const updatedUrl = localStorage.getItem("apiEndpoint");
  const baseURL = updatedUrl?.length ? updatedUrl : window.config.apiEndpoint;
  const filterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const onClickSearch = () => {
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    let queryParams = `?`;
    if (filter?.roomType) {
      queryParams = queryParams + `RoomType=${filter?.roomType}&`;
    }
    if (filter?.status) {
      queryParams = queryParams + `Status=${filter?.status}&`;
    }
    if (filter?.roomName) {
      queryParams = queryParams + `RoomName=${filter?.roomName}&`;
    }
    if (filter?.ClosedAt) {
      queryParams = queryParams + `ClosedAt=${filter?.ClosedAt}&`;
    }
    if (filter?.CreatedAt) {
      queryParams = queryParams + `CreatedAt=${filter?.CreatedAt}&`;
    }
    if (rowsPerPage) {
      queryParams = queryParams + `Limit=${rowsPerPage}&`;
    }
    if (offset) {
      queryParams = queryParams + `Offset=${offset}&`;
    }
    //  RoomType=${filter?.roomType}&Status=${filter?.status}&RoomName=${filter?.roomName}&ClosedAt=${filter?.ClosedAt}&CreatedAt=${filter?.CreatedAt}
    axios
      .get(`${baseURL}/accounts/${acId}/room${queryParams}`, {
        headers: headers,
      })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
  };

  const onClickClear = () => {
    setFilter({
      status: "CREATED,RESERVED",
      roomName: "",
      roomType: "",
      CreatedAt: "",
      ClosedAt: "",
    });
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window?.config?.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    axios
      .get(`${baseURL}/accounts/${acId}/room?Status=RESERVED,CREATED`, {
        headers: headers,
      })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
  };

  return (
    <div>
      <Grid
        container
        xs={12}
        md={12}
        lg={12}
        style={
          isMatch === true
            ? {
                height: "100%",
                width: "300px",
              }
            : {
                textAlign: "center",
                // width: "100%",
                borderBlockColor: "black",
                // margin: "auto",
                height: "100%",
                // overflow:"hidden",
                width: "1000px",
              }
        }
      >
        <Grid
          xs={12}
          md={12}
          lg={12}
          container
          style={{
            backgroundColor: "#3f51b5",
            height: "70px",
            marginBottom: "25px",
          }}
        >
          <Grid xs={10} md={11} lg={11} item>
            <Typography
              style={{
                marginTop: "3vh",
                fontWeight: "bold",
                color: "white",
                fontSize: "19px",
                marginBottom: "3vh",
                textAlign: "center",
                overflowY: "hidden",
              }}
            >
              {heading}
            </Typography>
          </Grid>
          <Grid xs={2} md={1} lg={1} item>
            <IconButton
              style={{
                marginTop: "1vh",
              }}
              onClick={() => {
                setList(false);
              }}
            >
              <CancelIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Grid
          xs={11}
          md={3}
          lg={3}
          item
          style={{ height: "5px", marginLeft: "5px" }}
        >
          <TextField
            style={{ marginBottom: "12px", marginLeft: "4px" }}
            fullWidth
            id="outlined-basic"
            label="Room Status"
            variant="outlined"
            name="status"
            select
            value={filter?.status}
            onChange={(e) => filterChange(e)}
            size="small"
            InputProps={{ style: { fontSize: 14 } }}
          >
            <option value="CREATED" key="CREATED">
              CREATED
            </option>
            <option value="CLOSED">CLOSED</option>
            <option value="RESERVED">RESERVED</option>
          </TextField>
        </Grid>
        <Grid xs={11} md={4} lg={4} item>
          <TextField
            inputProps={{ style: { fontSize: 15 } }}
            style={
              isMatch === true
                ? {
                    marginTop: "40px",
                    marginLeft: "10px",
                    forntSize: "2px",
                  }
                : {
                    marginBottom: "10px",
                    marginLeft: "10px",
                    forntSize: "2px",
                  }
            }
            fullWidth
            id="outlined-basic"
            label="Search Room Name"
            variant="outlined"
            name="roomName"
            // select
            value={filter?.roomName}
            onChange={(e) => filterChange(e)}
            size="small"
          />
        </Grid>
        <Grid xs={11} md={4} lg={4} item>
          <TextField
            inputProps={{ style: { fontSize: 15 } }}
            style={
              isMatch === true
                ? { marginTop: "5px", marginLeft: "10px" }
                : { marginBottom: "10px", marginLeft: "15px" }
            }
            fullWidth
            label="Search Room Type"
            variant="outlined"
            name="roomType"
            select
            value={filter?.roomType}
            onChange={(e) => filterChange(e)}
            size="small"
          >
            {/* <option disabled>Select RoomType</option> */}
            {/* <option key="2" value="2">2</option> */}
             {roomTypes.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </TextField> 
          {/* <TextField
            style={{ marginBottom: "12px", marginLeft: "4px" }}
            fullWidth
            id="outlined-basic"
            label="roomType"
            variant="outlined"
            name="status"
            select
            value={filter?.roomType}
            onChange={(e) => filterChange(e)}
            size="small"
            InputProps={{ style: { fontSize: 14 } }}
          >
            <option value="CREATED" key="CREATED">
              CREATED
            </option>
            <option value="CLOSED">CLOSED</option>
            <option value="RESERVED">RESERVED</option>
          </TextField> */}
        </Grid>
        <Grid xs={11} md={3} lg={3} item>
          <TextField
            inputProps={{ style: { fontSize: 15 } }}
            style={
              isMatch === true
                ? { marginTop: "5px", marginLeft: "10px" }
                : { marginBottom: "10px", marginLeft: "9px" }
            }
            fullWidth
            id="outlined-basic"
            label="Created At"
            // type="date"
            variant="outlined"
            name="CreatedAt"
            type="date"
            format="YYYY-MM-DD"
            // select
            value={filter?.CreatedAt}
            onChange={(e) => filterChange(e)}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid xs={11} md={4} lg={4} item>
          <TextField
            inputProps={{ style: { fontSize: 15 } }}
            style={
              isMatch === true
                ? { marginTop: "5px", marginLeft: "10px" }
                : { marginBottom: "10px", marginLeft: "15px" }
            }
            fullWidth
            id="outlined-basic"
            label="Closed At"
            variant="outlined"
            name="ClosedAt"
            type="date"
            format="YYYY-MM-DD"
            // select
            value={filter?.ClosedAt}
            onChange={(e) => filterChange(e)}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid xs={6} md={3} lg={3} item>
          <Button
            onClick={onClickClear}
            variant="contained"
            color="primary"
            style={
              isMatch === true
                ? { marginTop: "5px", marginLeft: "10px" }
                : { height: "33px", marginTop: "3px" }
            }
          >
            Clear
          </Button>
        </Grid>
        <Grid xs={6} md={2} lg={2} item>
          <Button
            onClick={onClickSearch}
            variant="contained"
            color="primary"
            style={
              isMatch === true
                ? { marginTop: "5px" }
                : {
                    width: "90px",
                    height: "33px",
                    marginTop: "3px",
                    marginLeft: "-55px",
                  }
            }
          >
            Search
          </Button>
        </Grid>
        {/* </Grid> */}
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          style={{ marginTop: "20px", paddingLeft: "10px" }}
        >
          <CustomPaginationActionsTable
            filter={filter}
            data={data}
            setData={setData}
            page={page}
            offset={offset}
            rowsPerPage={rowsPerPage}
            setPage={setPage} 
            setRowsPerPage={setRowsPerPage}
            setOffset={setOffset}
            sip={sip}
            setList={setList}
            makeCall={makeCall}
          />
        </Grid>
        {/* </Grid> */}
      </Grid>
    </div>
    // </>
  );
};

ListComponent.propTypes = {
  setList: PropTypes.any,
  handleClick: PropTypes.any,
  handleChange: PropTypes.any,
  heading: PropTypes.string,
  sip: PropTypes.any,
  makeCall: PropTypes.any,
  // data: PropTypes.any,
};

export default ListComponent;
